export default __webpack_public_path__ + "static/media/dashboard_black.058a70ac.svg";